<template>
  <div>
    <br>
    <v-data-table :headers="headers" :items="parosIncompletos" :loading="loadingParosIncompletos">
      <template v-slot:top>
        <div class="d-flex justify-center aling-center">
          <v-text-field v-model="horas" class="mx-3" label="Duración Máxima Del Paro (horas)"
            :loading="loadingParosIncompletos" :disabled="loadingParosIncompletos" />
          <v-text-field v-model="minutos" class="mx-3" label="Duración Máxima Del Paro (minutos)"
            :loading="loadingParosIncompletos" :disabled="loadingParosIncompletos" />
          <v-btn color="primary" @click="getParosIncompletos()" :loading="loadingParosIncompletos">Buscar</v-btn>
        </div>
      </template>

      <template v-slot:item.tiempoParoMantenimiento="{ item }">
        {{ item.tiempoMantenimiento }}
      </template>
      <template v-slot:item.nombresRolesReparacion="{ item }">
        <v-list dense>
          <v-list-item-group>
            <v-list-item v-for="(item, i) in item.nombresRolesReparacion" :key="i">
              <v-list-item-content>
                <v-list-item-title v-text="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

      </template>
      <template v-slot:item.estado="{ item }">
        <v-chip v-if="item.fechaRespuesta" color="success" dark>
          Atendido Desde {{ item.fechaRespuesta }}
        </v-chip>
        <v-chip v-else color="error" dark>
          Sin Atención
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      headers: [
        {
          text: "Inicio",
          value: "paroInicio",
          align: "center",
          sortable: true,
        }, {
          text: "Area",
          value: "nombreArea",
          align: "center",
          sortable: true,
        }, {
          text: "Máquina",
          value: "nombreMaquina",
          align: "center",
          sortable: true,
        }, {
          text: "A Cargo de",
          value: "nombresRolesReparacion",
          align: "center",
          sortable: true,
        }, {
          text: "Estado",
          value: "estado",
          align: "center",
          sortable: true,
        }, {
          text: "Tiempo En Mantenimiento",
          value: "tiempoParoMantenimiento",
          align: "center",
          sortable: true,
        }, {
          text: "Tiempo En paro",
          value: "tiempoParoActivo",
          align: "center",
          sortable: true,
        },
      ],
      parosIncompletos: [],
      horas: null,
      minutos: null,
      loadingParosIncompletos: false,
    }
  },
  methods: {
    initialize() {
      this.getParosIncompletos();
    },
    getParosIncompletos() {
      this.loadingParosIncompletos = true;
      const params = new URLSearchParams();
      if (this.horas != null && this.horas > 0) {
        params.append('horas', this.horas);
      }
      if (this.minutos != null && this.minutos > 0) {
        params.append('mins', this.minutos);
      }
      axios
        .get(`/Mantenimientos/ReporteTiemposMantenimiento?${params.toString()}`)
        .then((response) => {
          this.parosIncompletos = response.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingParosIncompletos = false;
        })
    },
  }
}
</script>